import React, {createContext, FunctionComponent, useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {IUser, IWorkspace} from '../models';
import {IState} from '../store/reducers';

interface UserWorkspaceContextProps {
  currentUser: IUser | null | undefined;
  currentWorkspace?: IWorkspace | null | undefined
}

const UserWorkspaceContext = createContext<UserWorkspaceContextProps>({
  currentUser: null,
  currentWorkspace: null
});

export const UserWorkspaceProvider: FunctionComponent = ({children}) => {
  const currentUser = useSelector((state: IState) => state.users?.user);
  const workspaces = useSelector((state: IState) => state.workspaces?.workspaces);

  const currentWorkspace = useMemo(() => workspaces?.find((workspace: any) => workspace.is_active), [workspaces]);

  return (
    <UserWorkspaceContext.Provider value={{currentUser, currentWorkspace}}>
      {children}
    </UserWorkspaceContext.Provider>
  );
};

export const useCurrentUser = () => {
  const {currentUser} = useContext(UserWorkspaceContext);

  return currentUser;
}

export const useCurrentWorkspace = () => {
  const {currentWorkspace} = useContext(UserWorkspaceContext);

  return currentWorkspace;
}

export const useSubscription = () => {
  const currentWorkspace = useCurrentWorkspace();

  return useMemo(() => currentWorkspace?.organization?.subscription_json || null, [currentWorkspace]);
}
